import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";

export const StudentInstructionModal = ({
    open,
    onClose,
    classCode,
}: {
    open: boolean;
    onClose: () => void;
    classCode: string;
}) => {
    const [isCopied, setIsCopied] = useState(false);
    const textTemplate = `1. 請同學點擊連結進入翰林AI寫作批改\n${" ".repeat(
        4
    )}https://chaiwriting-h.hle.com.tw/\n2. 登入教育雲或翰林帳號\n3. 點擊【加入班級】\n4. 輸入班級邀請碼：${classCode}`;
    return (
        <div
            onClick={onClose}
            className={`fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-20 p-4 ${open ? "block" : "hidden"
                }`}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white px-6 py-6 md:px-20 md:py-10 rounded-lg flex flex-col gap-4 w-full max-w-[600px] max-h-[90vh] overflow-y-auto items-center"
            >
                <div className="flex items-center justify-center p-4 bg-primary-light text-lg font-medium text-white rounded-sm w-full">
                    已建立班級
                </div>
                <div className="text-center text-gray-600 text-base">
                    將邀請碼提供給學生，學生即可開始使用
                </div>
                <div className="bg-primary-light/15 border-primary-light/50 border-2 p-4 rounded-sm flex flex-col gap-y-2 w-full">
                    <span className="text-lg font-medium text-center"></span>
                    <span className="flex flex-col">
                        <span className="text-gray-800">1. 請同學點擊連結進入翰林AI寫作批改</span>
                        <a
                            href="https://chaiwriting-h.hle.com.tw/"
                            target="_blank"
                            className="ml-[1em] text-primary-light break-all"
                        >
                            https://chaiwriting-h.hle.com.tw/
                        </a>
                    </span>
                    <span className="text-gray-800">2. 登入教育雲或翰林帳號</span>
                    <span className="text-gray-800">3. 點擊【加入班級】</span>
                    <span className="text-gray-800">4. 輸入班級邀請碼：{classCode}</span>
                    <Button
                        sx={{
                            width: "fit-content",
                            px: "24px",
                            py: "8px",
                            alignSelf: "center",
                            mt: "1em",
                        }}
                        variant="contained"
                        startIcon={isCopied ? <CheckIcon /> : <ContentCopyIcon />}
                        onClick={() => {
                            navigator.clipboard.writeText(textTemplate);
                            setIsCopied(true);
                            // 2秒後恢復原狀
                            setTimeout(() => {
                                setIsCopied(false);
                            }, 2000);
                        }}
                    >
                        {isCopied ? "複製成功" : "複製說明"}
                    </Button>
                </div>
                <div className="text-center text-gray-600 text-sm mt-4">
                    點擊網站上方[班級列表]，可以再次複製說明
                </div>
                <Button
                    sx={{
                        width: "fit-content",
                        px: "32px",
                        py: "8px",
                        alignSelf: "center",
                        mt: "16px",
                    }}
                    variant="outlined"
                    onClick={onClose}
                >
                    關閉
                </Button>
            </div>
        </div>
    );
};